module.exports = __webpack_public_path__ + "img/credit-card-main.3d4236e.png";